import { graphql } from 'react-relay';
import { useEffect } from 'react';

import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError.ts';
import { isExpectedApolloError } from '@confluence/error-boundary/entry-points/expectedGraphQlErrorHelper.ts';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop-utils/entry-points/ApolloErrorInterop.ts';

import type {
	usePageTitlePageTitleQuery as usePageTitlePageTitleQuery$data,
	usePageTitlePageTitleQueryVariables as usePageTitlePageTitleQuery$variables,
} from './__types__/usePageTitlePageTitleQuery.ts';
export const usePageTitle = ({
	contentId,
}: {
	contentId: string;
}): {
	title: string | null | undefined;
	error: ApolloErrorInterop | undefined;
} => {
	const { data, error } = useQueryInterop<
		usePageTitlePageTitleQuery$data,
		usePageTitlePageTitleQuery$variables
	>(
		graphql`
			query usePageTitlePageTitleQuery($contentId: ID!) {
				singleContent(id: $contentId) {
					id
					title
				}
			}
		`,
		{
			variables: { contentId },
		},
	);
	useEffect(() => {
		if (error && (isUnauthorizedError(error) || isExpectedApolloError(error))) {
			markErrorAsHandled(error);
		}
	}, [error]);
	return { title: data?.singleContent?.title, error };
};
